<div *ngIf="_expanded" class="w-screen max-w-xs bg-bluemine-500">
  <div class="overflow-hidden pb-2 shadow-lg ring-1 ring-black ring-opacity-5">
    <div class="relative bg-bluemine-500">
      <lib-nav-popover-item *ngFor="let node of nodes" [node]="node">
      </lib-nav-popover-item>
    </div>
  </div>
</div>
